/* OKCA motion: FLIP con reconciliación por clave, salidas, contador, skeleton, pulse y chips. Vanilla ES5. */
(function () {
  'use strict';
  window.OKCA = window.OKCA || {};

  var EASE = 'cubic-bezier(.23,1,.32,1)';   // ease-out fuerte
  var SPRING = 'cubic-bezier(.34,1.56,.64,1)'; // solo para feedback de pulsación
  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function reduced() { return !!(mq && mq.matches); }
  function canWAAPI(el) { return !!(el && el.animate); }

  // ---- Estado de la animación en curso (interrumpible) ----
  var anims = [];        // animaciones vivas
  var clones = [];       // clones de salida vivos
  var posHost = null;    // contenedor al que forzamos position:relative

  function restorePos() {
    if (posHost) { posHost.style.position = ''; posHost = null; }
  }
  function untrack(a) {
    var i = anims.indexOf(a);
    if (i > -1) anims.splice(i, 1);
    if (!anims.length) restorePos();
  }
  function track(a, clone) {
    anims.push(a);
    if (clone) clones.push(clone);
    a.onfinish = function () {
      if (clone) { removeNode(clone); var j = clones.indexOf(clone); if (j > -1) clones.splice(j, 1); }
      untrack(a);
    };
    a.oncancel = function () { untrack(a); };
    return a;
  }
  function removeNode(n) { if (n && n.parentNode) n.parentNode.removeChild(n); }

  // Termina todo en seco: estado final, sin clones ni estilos residuales
  function settle() {
    var list = anims.slice(), i;
    anims = [];
    for (i = 0; i < list.length; i++) {
      try { list[i].finish(); } catch (e) { try { list[i].cancel(); } catch (e2) {} }
    }
    for (i = 0; i < clones.length; i++) removeNode(clones[i]);
    clones = [];
    restorePos();
  }

  function isHero(el) {
    var c = el.classList;
    return !!(c && (c.contains('okcr-hero') || c.contains('okca__card--best')));
  }

  // Reutiliza las <img> ya cargadas del nodo viejo en el nuevo (sin recarga ni parpadeo)
  function keepImgs(oldEl, newEl) {
    var oi = oldEl.querySelectorAll('img'), ni = newEl.querySelectorAll('img'), j, a, b;
    for (j = 0; j < ni.length && j < oi.length; j++) {
      a = oi[j]; b = ni[j];
      if (a.getAttribute('src') === b.getAttribute('src') &&
          a.getAttribute('width') === b.getAttribute('width') &&
          a.getAttribute('height') === b.getAttribute('height') &&
          b.parentNode) {
        b.parentNode.replaceChild(a, b);
      }
    }
  }

  function flip(container, render) {
    if (!container) { if (render) render(); return; }
    if (reduced() || !canWAAPI(container)) {
      // Movimiento reducido: sin desplazamientos; las tarjetas nuevas solo aparecen con un fundido corto.
      var had = {}, ks = container.children, q;
      for (q = 0; q < ks.length; q++) { var kk = ks[q].getAttribute('data-key'); if (kk) had[kk] = true; }
      settle(); render();
      if (canWAAPI(container)) for (q = 0; q < container.children.length; q++) {
        var nk = container.children[q].getAttribute('data-key');
        if (nk && !had[nk]) track(container.children[q].animate([{ opacity: 0 }, { opacity: 1 }], { duration: 150, easing: 'linear', fill: 'backwards' }));
      }
      return;
    }

    // ---- Lectura 1: posiciones y HTML de los nodos actuales ----
    // Se mide ANTES de cerrar las animaciones en curso: getBoundingClientRect incluye el transform de la
    // animación, así que es la posición que se ve en pantalla. Si se cerrara antes (settle), cada tarjeta
    // que iba a medio camino saltaría a su sitio final y el nuevo movimiento partiría de ahí (tirón al
    // tocar filtros seguidos).
    var kids = container.children, old = {}, i, el, k, o;
    var oldHeroKey = null, oldList = [];
    for (i = 0; i < kids.length; i++) {
      el = kids[i];
      k = el.getAttribute('data-key');
      if (!k || old[k]) continue;
      o = { key: k, el: el, rect: el.getBoundingClientRect(), html: el.outerHTML };
      old[k] = o; oldList.push(o);
      if (oldHeroKey === null && isHero(el)) oldHeroKey = k;
    }
    var vh = window.innerHeight || 800;

    settle();
    render();

    // ---- Reconciliación por clave: el nodo viejo vuelve si no ha cambiado ----
    var nodes = [], used = {}, n, key;
    for (i = 0; i < container.children.length; i++) nodes.push(container.children[i]);
    for (i = 0; i < nodes.length; i++) {
      n = nodes[i];
      key = n.getAttribute('data-key');
      o = key && old[key];
      if (!o || used[key]) continue;
      used[key] = true;
      if (o.html === n.outerHTML) { container.replaceChild(o.el, n); nodes[i] = o.el; }
      else keepImgs(o.el, n);
    }

    // ---- Lectura 2: posiciones finales (una sola pasada) ----
    var cr = container.getBoundingClientRect();
    var items = [], newHero = null, newHeroKey = null, r;
    for (i = 0; i < nodes.length; i++) {
      key = nodes[i].getAttribute('data-key');
      if (!key) continue;
      r = nodes[i].getBoundingClientRect();
      items.push({ key: key, el: nodes[i], rect: r });
      if (newHero === null && isHero(nodes[i])) { newHero = items[items.length - 1]; newHeroKey = key; }
    }
    var cl = container.clientLeft || 0, ct = container.clientTop || 0;
    var sl = container.scrollLeft || 0, st = container.scrollTop || 0;
    var hostStatic = false;
    try { hostStatic = window.getComputedStyle(container).position === 'static'; } catch (e) {}

    // ---- Escritura: ya no se lee layout ----
    var heroChanged = !!(newHero && oldHeroKey && newHeroKey !== oldHeroKey);
    var hd = 0, heroBottom = 0, dur = 300;
    if (heroChanged && old[oldHeroKey]) {
      hd = old[oldHeroKey].rect.height - newHero.rect.height; // viejo - nuevo
      if (Math.abs(hd) < 2) hd = 0;
      heroBottom = newHero.rect.bottom;
      if (hd) dur = 280; // misma duración que la altura para que los de debajo cuadren
    }

    var enterIdx = 0, it, ob, dx, dy, a, visNew, visOld, sib;
    for (i = 0; i < items.length; i++) {
      it = items[i];
      r = it.rect;
      if (heroChanged && it === newHero) {
        // Hero nuevo: crossfade del contenido y altura de viejo a nuevo (la carcasa no salta)
        var ch = it.el.children, c;
        for (c = 0; c < ch.length; c++) {
          track(ch[c].animate(
            [{ opacity: 0, transform: 'translateY(6px)' }, { opacity: 1, transform: 'translateY(0)' }],
            { duration: 240, easing: EASE, fill: 'backwards' }
          ));
        }
        if (hd) {
          track(it.el.animate(
            [{ height: old[oldHeroKey].rect.height + 'px' }, { height: r.height + 'px' }],
            { duration: 280, easing: EASE }
          ));
        }
        continue;
      }
      ob = old[it.key];
      visNew = r.bottom >= -100 && r.top <= vh + 100;
      if (ob) {
        // Mover (FLIP, solo transform)
        dx = ob.rect.left - r.left;
        dy = ob.rect.top - r.top;
        // Si el hero cambia de altura, los de debajo se compensan para no dar tirones
        if (hd && r.top >= heroBottom - 1) dy -= hd;
        if (Math.abs(dx) < 2 && Math.abs(dy) < 2) continue;
        visOld = ob.rect.bottom >= -100 && ob.rect.top <= vh + 100;
        if (!visNew && !visOld) continue;
        track(it.el.animate(
          [{ transform: 'translate(' + dx + 'px,' + dy + 'px)' }, { transform: 'translate(0,0)' }],
          { duration: dur, easing: EASE }
        ));
      } else {
        // Entrar: solo si está en pantalla o cerca
        if (!visNew) continue;
        track(it.el.animate(
          [
            { opacity: 0, transform: 'translateY(10px) scale(.985)' },
            { opacity: 1, transform: 'translateY(0) scale(1)' }
          ],
          { duration: 260, delay: Math.min(enterIdx, 4) * 30, easing: EASE, fill: 'backwards' }
        ));
        enterIdx++;
      }
    }

    // Salidas: clon absoluto en su posición vieja que se desvanece
    var firstExit = true, clone, cs;
    for (i = 0; i < oldList.length; i++) {
      o = oldList[i];
      if (used[o.key]) continue;
      r = o.rect;
      if (r.bottom < -100 || r.top > vh + 100) continue;
      if (firstExit) {
        firstExit = false;
        if (hostStatic) { container.style.position = 'relative'; posHost = container; }
      }
      clone = o.el.cloneNode(true);
      clone.removeAttribute('data-key');
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('inert', '');
      clone.setAttribute('data-okca-exit', '');
      cs = clone.style;
      cs.position = 'absolute';
      cs.margin = '0';
      cs.boxSizing = 'border-box';
      cs.left = (r.left - cr.left - cl + sl) + 'px';
      cs.top = (r.top - cr.top - ct + st) + 'px';
      cs.width = r.width + 'px';
      cs.height = r.height + 'px';
      cs.pointerEvents = 'none';
      cs.zIndex = '0';
      container.appendChild(clone);
      a = clone.animate(
        [{ opacity: 1, transform: 'scale(1)' }, { opacity: 0, transform: 'scale(.96)' }],
        { duration: 140, easing: EASE, fill: 'forwards' }
      );
      track(a, clone);
    }
  }

  // ---- Tween numérico con rAF + tick vertical ----
  function fmt(n) {
    try { return new Intl.NumberFormat('es-ES').format(n); } catch (e) { return String(n); }
  }
  function readNum(el) {
    var n = parseInt(String(el.textContent || '').replace(/[^\d-]/g, ''), 10);
    return isNaN(n) ? 0 : n;
  }
  function tween(el, to, opts) {
    if (!el) return;
    var ms = (opts && opts.ms) || 360;
    if (el.__okcaRaf) { cancelAnimationFrame(el.__okcaRaf); el.__okcaRaf = 0; }
    to = Math.round(+to) || 0;
    var from = readNum(el);
    if (reduced() || from === to || !window.requestAnimationFrame) {
      el.textContent = fmt(to);
      return;
    }
    // Tick sutil al cambiar el número
    if (canWAAPI(el)) {
      try {
        if (el.__okcaTick) el.__okcaTick.cancel();
        el.__okcaTick = el.animate(
          [{ transform: 'translateY(4px)', opacity: 0.4 }, { transform: 'translateY(0)', opacity: 1 }],
          { duration: 180, easing: EASE }
        );
      } catch (e) {}
    }
    var t0 = null;
    function step(t) {
      if (t0 === null) t0 = t;
      var p = Math.min(1, (t - t0) / ms);
      var e = 1 - Math.pow(1 - p, 3); // easeOutCubic
      el.textContent = fmt(Math.round(from + (to - from) * e));
      if (p < 1) { el.__okcaRaf = requestAnimationFrame(step); }
      else { el.__okcaRaf = 0; el.textContent = fmt(to); }
    }
    el.__okcaRaf = requestAnimationFrame(step);
  }

  // ---- Skeleton ----
  function injectCSS() {
    if (document.getElementById('okca-motion-css')) return;
    var s = document.createElement('style');
    s.id = 'okca-motion-css';
    s.textContent =
      '.okca-sk{pointer-events:none}' +
      '.okca-sk .okca-sk-i,.okca-sk .okca-sk-b{background:#F6EFE3;background-image:linear-gradient(90deg,#F6EFE3 0%,#EFE6D6 50%,#F6EFE3 100%);background-size:200% 100%;animation:okca-m-shimmer 1.4s linear infinite;}' +
      '.okca-sk .okca-sk-i{display:block;aspect-ratio:1/1;width:100%}' +
      '.okca-sk .okca-sk-bd{padding:12px 12px 14px;display:flex;flex-direction:column;gap:8px}' +
      '.okca-sk .okca-sk-b{height:12px;border-radius:6px}' +
      '.okca-sk .okca-sk-b:nth-child(1){width:46%;height:22px}' +
      '.okca-sk .okca-sk-b:nth-child(2){width:88%}' +
      '.okca-sk .okca-sk-b:nth-child(3){width:62%}' +
      '.okca-sk .okca-sk-btn{height:44px;border-radius:4px;margin-top:8px;width:100%}' +
      '@keyframes okca-m-shimmer{0%{background-position:200% 0}100%{background-position:-200% 0}}' +
      '@media (prefers-reduced-motion:reduce){.okca-sk .okca-sk-i,.okca-sk .okca-sk-b{animation:none;background-image:none}}';
    document.head.appendChild(s);
  }
  function skeleton(container, n) {
    if (!container) return;
    injectCSS();
    var html = '', i;
    n = n || 8;
    for (i = 0; i < n; i++) {
      html += '<li class="okca__card okca-sk" aria-hidden="true">' +
        '<span class="okca-sk-i"></span>' +
        '<div class="okca-sk-bd"><span class="okca-sk-b"></span><span class="okca-sk-b"></span><span class="okca-sk-b"></span>' +
        '<span class="okca-sk-b okca-sk-btn"></span></div></li>';
    }
    container.innerHTML = html;
    container.setAttribute('aria-busy', 'true');
  }
  function unskeleton(container) {
    if (container) container.removeAttribute('aria-busy');
  }

  // ---- Confirmación del botón añadir ----
  function pulse(el) {
    if (!el || reduced() || !canWAAPI(el)) return;
    el.animate(
      [{ transform: 'scale(.96)' }, { transform: 'scale(1)' }],
      { duration: 180, easing: SPRING }
    );
  }

  // ---- Chips: pulsación táctil ----
  // Rebote corto con tilde de overshoot (único sitio donde se permite)
  function press(btn) {
    if (!btn || reduced() || !canWAAPI(btn)) return;
    btn.animate(
      [{ transform: 'scale(.96)' }, { transform: 'scale(1)' }],
      { duration: 220, easing: SPRING }
    );
  }

  function pressDown(btn) {
    btn.style.transition = 'transform 90ms ease-out';
    btn.style.transform = 'scale(.97)';
  }
  function pressUp(btn) {
    btn.style.transition = 'transform 180ms ' + EASE;
    btn.style.transform = '';
    // Con temporizador y no con transitionend: si el transform no llegó a cambiar, ese evento no salta y
    // el escuchador se quedaba colgado.
    setTimeout(function () { if (!btn.__okcaDown) btn.style.transition = ''; }, 200);
  }

  // Delegado en root: estado de pulsación inmediato en pointerdown
  function attachChips(root) {
    root = root || document;
    if (root.__okcaChips) return;
    root.__okcaChips = true;
    root.addEventListener('pointerdown', function (e) {
      if (reduced() || (e.button !== undefined && e.button > 0)) return;
      var t = e.target, btn = t && t.closest ? t.closest('.okca__chips button') : null;
      if (!btn || btn.disabled || btn.__okcaDown) return;
      btn.__okcaDown = true;
      pressDown(btn);
      var release = function () {
        btn.removeEventListener('pointerup', release);
        btn.removeEventListener('pointerleave', release);
        btn.removeEventListener('pointercancel', release);
        btn.__okcaDown = false;
        pressUp(btn);
      };
      btn.addEventListener('pointerup', release);
      btn.addEventListener('pointerleave', release);
      btn.addEventListener('pointercancel', release);
    }, { passive: true });
  }

  // Autoengancha en el documento: no hace falta tocar el call-site
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { attachChips(document); });
  } else {
    attachChips(document);
  }

  window.OKCA.motion = {
    flip: flip,
    tween: tween,
    skeleton: skeleton,
    unskeleton: unskeleton,
    pulse: pulse,
    press: press,
    attachChips: attachChips
  };
})();
